import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function AreaPlanRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/area-plan', component: Index, isProtected: true, permissions: ['area_plan_index']},
    {path: '/area-plan/create', component: Create, isProtected: true, permissions: ['area_plan_create']},
    {path: '/area-plan/edit/:id', component: Edit, isProtected: true, permissions: ['area_plan_edit']},

  ];

  return routes;
}
